import { debug as logDebug, error as logError, info as logInfo } from 'core/messaging/logger/logger';
import { HeaderProps } from '@agoda/layout';
import { BootstrapConfig } from 'core/type/BootstrapConfig.types';
import { NavigationState } from 'store/slice';
import { HeaderEventHandlers } from 'component/common/Header/ActivitiesHeader.types';
import { mapHeaderAnalyticsProps, mapHeaderCallbackProps, mapHeaderCoreProps, mapHeaderExperimentProps, mapHeaderFetchApiProps } from 'component/common/Header/header.selectors';
import { CommonHeaderProps } from 'core/type/header.types';
import { getHeader, getWebAnalytics } from 'core/window/windowService';
import { BehaviorManager } from '@behavior-management/core';
import InternalResolverFactory from 'behaviorManagement/resolverFactory';
import { getShoppingCartBehavior } from 'core/utils/cart';
import { ActivitiesBMProvider } from 'behaviorManagement/activitiesBMProvider';

const getHeaderBaseProps = (config: BootstrapConfig, headerBaseProps: CommonHeaderProps) => {
    headerBaseProps.params.config.isSticky = false;
    return headerBaseProps;
};

export const mapDesktopHeaderProps = (state: NavigationState, handlers: HeaderEventHandlers, headerProps: CommonHeaderProps, config: BootstrapConfig): HeaderProps => {
    const headerCoreProps = mapHeaderCoreProps(headerProps, config);
    const headerBaseProps = getHeaderBaseProps(config, headerProps);
    const analyticsProps = mapHeaderAnalyticsProps(state.pageTypeId);
    const callbackProps = mapHeaderCallbackProps(state, config, handlers);
    const fetchApiProps = mapHeaderFetchApiProps(config);
    const experimentProps = mapHeaderExperimentProps(config, headerProps);
    const isCartBehaviorEnabled = getShoppingCartBehavior(config);
    const activitiesBMProvider = new ActivitiesBMProvider();

    return {
        ...headerCoreProps,
        ...headerBaseProps,
        ...callbackProps,
        ...fetchApiProps,
        ...analyticsProps,
        dataId: 'data-element-name',
        shouldShowCurrency: true,
        whiteLabelId: config.whiteLabelId,
        logger: {
            info: logInfo,
            debug: logDebug,
            error: logError,
        },
        experiments: {
            ...getHeader().experiments,
            ...experimentProps,
        },
        isCartIngressEnable: isCartBehaviorEnabled,
        isResponsiveHeaderEnabled: config.behavior.header.isResponsiveHeaderEnabled,
        getBehaviorManager: () => new BehaviorManager(InternalResolverFactory(config, headerProps), activitiesBMProvider),
        isBlackHeader: config.behavior.header.isBlackHeaderBackground,
        getWebAnalytics,
    };
};
